import { render } from "./ContentMenu.vue?vue&type=template&id=cf8801dc&scoped=true"
import script from "./ContentMenu.vue?vue&type=script&lang=js"
export * from "./ContentMenu.vue?vue&type=script&lang=js"

import "./ContentMenu.vue?vue&type=style&index=0&id=cf8801dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf8801dc"]])

export default __exports__